<template>
  <div class="user-search-page">
    <div class="user-search-shell">
      <section class="search-hero">
        <div class="search-hero__copy">
          <div class="search-hero__icon" aria-hidden="true">
            <v-icon>mdi-account-search-outline</v-icon>
          </div>
          <div>
            <span class="search-eyebrow">KUNDEN &amp; BENUTZER</span>
            <h1>Benutzersuche</h1>
            <p>Kunden finden, Betreuung nachvollziehen und alle relevanten Angaben an einem Ort bearbeiten.</p>
          </div>
        </div>
        <div class="search-hero__actions">
          <v-btn
            v-if="userService.hasRight('u_rightList')"
            outlined
            class="search-action search-action--secondary"
            @click="$router.push('/dashboard/user/rightlist')">
            <v-icon left>mdi-shield-account-outline</v-icon>
            Rechte-Liste
          </v-btn>
          <v-btn color="primary" depressed class="search-action" @click="showRegisterDialog = true">
            <v-icon left>mdi-account-plus-outline</v-icon>
            Neuer Benutzer
          </v-btn>
        </div>
      </section>

      <section class="search-surface">
        <div class="search-surface__heading">
          <div>
            <span class="search-eyebrow">DIREKTSUCHE</span>
            <h2>Wen möchtest du öffnen?</h2>
            <p>Suche nach Name, E-Mail oder weiteren Angaben aus der bestehenden Benutzersuche.</p>
          </div>
        </div>
        <user-search style="display: flex; flex-direction: row" dark filled label="Suche" return-user @update="editrollen" />
      </section>
    </div>

    <register :auto-login="false" :active="showRegisterDialog" @register="newAccountRegistered" @close="showRegisterDialog = false" />
  </div>
</template>

<script>
import userSearch from "../../../components/userSearch.vue"
import register from "../../launchScreen/register.vue"
import userService from "../../../services/userService"
import attendanceCheckinsApi from "../../../api/attendanceCheckinsApi"

export default {
  name: "UserDashboardSearch",
  components: {
    register,
    userSearch,
  },
  data() {
    return {
      userService,
      showRegisterDialog: false,
    }
  },
  methods: {
    editrollen(user) {
      if (user && user._id) this.$router.push(`/dashboard/user/search/${user._id}`)
    },
    async newAccountRegistered(user) {
      this.showRegisterDialog = false
      if (!user || !user._id) return
      try {
        await attendanceCheckinsApi.recordTrainerpointAccountCreated(user._id)
      } catch (error) {
        console.warn("Kontoerstellung konnte nicht für die Trainerpoint-Tagesliste protokolliert werden:", error)
      }
      this.editrollen(user)
    },
  },
}
</script>

<style scoped>
.user-search-page {
  --us-primary: #009640;
  --us-surface: rgba(0, 0, 0, 0.2);
  --us-surface-raised: rgba(255, 255, 255, 0.045);
  --us-border: rgba(255, 255, 255, 0.1);
  --us-text: #f5f6f5;
  --us-muted: #a5aaa6;
  min-height: 100%;
  padding: clamp(16px, 2.5vw, 36px);
  color: var(--us-text);
  background: transparent;
}

.user-search-shell {
  width: 100%;
  max-width: 1480px;
  margin: 0 auto;
}

.search-hero {
  position: relative;
  display: flex;
  min-height: 154px;
  align-items: center;
  justify-content: space-between;
  gap: 28px;
  padding: clamp(24px, 3vw, 40px);
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.14);
  border-radius: 24px;
  background: radial-gradient(circle at 92% 8%, rgba(0, 150, 64, 0.12), transparent 34%),
    linear-gradient(110deg, rgba(0, 0, 0, 0.3), rgba(255, 255, 255, 0.025)), var(--us-surface);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.24);
  backdrop-filter: blur(18px);
}

.search-hero::after {
  position: absolute;
  top: -120px;
  right: -60px;
  width: 340px;
  height: 340px;
  border: 1px solid rgba(0, 150, 64, 0.12);
  border-radius: 50%;
  content: "";
  pointer-events: none;
}

.search-hero__copy {
  z-index: 1;
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 18px;
}

.search-hero__icon {
  display: inline-flex;
  flex: 0 0 auto;
  width: 62px;
  height: 62px;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(0, 150, 64, 0.34);
  border-radius: 19px;
  color: #d8f3e2;
  background: rgba(0, 150, 64, 0.16);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.08), 0 10px 24px rgba(0, 0, 0, 0.16);
}

.search-hero__icon .v-icon {
  color: inherit;
  font-size: 31px;
}

.search-eyebrow {
  display: block;
  margin-bottom: 5px;
  color: #65ca8b;
  font-size: 12px;
  font-weight: 850;
  letter-spacing: 0.13em;
  line-height: 1.2;
}

.search-hero h1 {
  margin: 0;
  color: #ffffff;
  font-size: clamp(29px, 3vw, 40px);
  font-weight: 780;
  letter-spacing: -0.04em;
  line-height: 1.1;
}

.search-hero p {
  max-width: 680px;
  margin: 8px 0 0;
  color: #aaafab;
  font-size: 15px;
  line-height: 1.5;
}

.search-hero__actions {
  z-index: 1;
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  gap: 10px;
}

.search-action {
  min-height: 47px;
  padding: 0 19px !important;
  border-radius: 13px;
  font-size: 13px;
  font-weight: 750;
  letter-spacing: 0 !important;
  text-transform: none !important;
}

.search-action--secondary {
  border-color: rgba(255, 255, 255, 0.16) !important;
  color: #e1e4e2 !important;
}

.search-surface {
  margin-top: 16px;
  padding: clamp(22px, 3vw, 34px);
  border: 1px solid var(--us-border);
  border-radius: 23px;
  background: linear-gradient(145deg, rgba(255, 255, 255, 0.045), rgba(0, 0, 0, 0.18)), var(--us-surface);
  box-shadow: 0 18px 50px rgba(0, 0, 0, 0.19);
}

.search-surface__heading {
  margin-bottom: 20px;
}

.search-surface h2 {
  margin: 0;
  color: #ffffff;
  font-size: 24px;
  letter-spacing: -0.03em;
}

.search-surface p {
  margin: 6px 0 0;
  color: var(--us-muted);
  font-size: 13px;
}

@media (max-width: 840px) {
  .search-hero {
    align-items: flex-start;
    flex-direction: column;
  }

  .search-hero__actions {
    width: 100%;
  }

  .search-hero__actions .v-btn {
    flex: 1 1 auto;
  }
}

@media (max-width: 600px) {
  .user-search-page {
    padding: 10px;
  }

  .search-hero {
    padding: 23px 19px;
  }

  .search-hero__copy {
    align-items: flex-start;
  }

  .search-hero__icon {
    width: 48px;
    height: 48px;
    border-radius: 15px;
  }

  .search-hero h1 {
    font-size: 28px;
  }

  .search-hero__actions {
    flex-direction: column;
  }

  .search-hero__actions .v-btn {
    width: 100%;
  }
}
</style>
